export const addGlobalError = (message) => ({
    type: 'ADD_ERROR',
    error: {type: 'global', message}
});

export const addFormError = (message) => ({
    type: 'ADD_ERROR',
    error: { type: 'form', message }
});

